module.exports = __webpack_public_path__ + "static/media/sfl_13.8a686114.jpg";